<div class="row bodyComponent">
  <div class="col-md-12">
    <div class="mat-elevation-z8">

      <mat-form-field *ngIf="config.searchField" class="inputSearch">
        <mat-label>Pesquisar</mat-label>
        <input matInput (keyup)="onSearchInput($event)">
      </mat-form-field>

      <mat-table [dataSource]="tableDataSrc" class="mat-elevation-z8" matSort>

        <ng-container *ngFor="let col of cols; let i = index;">
          <ng-container matColumnDef="{{ col }}">
            <mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                [ngStyle]="{
                    width: config.columnWidths[col] || 'auto',
                    'min-width': config.columnWidths[col] || 'auto',
                    'max-width': config.columnWidths[col] || 'auto'
                }">
                <span [title]="returnTitleName(i)">{{
                    'CUSTOMLIST.' + config.tableTranslate + '.' + 'COLUNS.' + col | translate
                }}</span>
            </mat-header-cell>

            <mat-cell
                *matCellDef="let element"
                [ngStyle]="{
                    width: config.columnWidths[col] || 'auto',
                    'min-width': config.columnWidths[col] || 'auto',
                    'max-width': config.columnWidths[col] || 'auto'
                }">
              <div [ngSwitch]="config.typeField[col]">

                <div *ngSwitchCase="'select'">
                  <div
                    *ngIf="element[col][0][config.selectConfig.nameProperties[0]] !== 0 && element[config.selectConfig.varResponse] === 0">
                    <mat-form-field class="matFormCustom">
                      <mat-select #matSelect>
                        <mat-option *ngFor="let item of element[col]"
                          (click)="onSelected(element, item[config.selectConfig.nameProperties[0]], item[config.selectConfig.nameProperties[1]]);"
                          value="{{ item }}">
                          {{ 'CUSTOMLIST.' + config.tableTranslate + '.' + 'VALUES.'+
                          item[config.selectConfig.nameProperties[0]] + " " + config.selectConfig.simbolDetach + " "
                          +item[config.selectConfig.nameProperties[1]] | translate}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div *ngIf="element[col][0][config.selectConfig.nameProperties[0]] === 0">
                    {{config.replaceValue}}
                  </div>

                  <div *ngIf="element[config.selectConfig.varResponse] !== 0">
                    <span triggers="mouseenter:mouseleave" [autoClose]="true"
                      [ngbTooltip]="'CUSTOMLIST.' + config.tableTranslate + '.' + 'VALUES.' + element.dataFile.audit.solution.name | translate">
                      {{element[config.selectConfig.varResponse]}}
                    </span>

                    <mat-icon *ngIf="element['lineStatusString'] === 'Pendency'" class="btnUndo"
                      (click)="editLine(element,$event)">reply</mat-icon>
                  </div>

                </div>

                <div *ngSwitchCase="'inform'">
                  <ng-template #htmlContentTooltipBillet>

                    <div class="tablePreviewCustom">
                      <table class="table">
                        <tr>
                          <th>Parcela</th>
                          <th>Pago</th>
                        </tr>
                        <tr *ngFor="let bs of element.dataReceiving; let i = index" [attr.data-index]="i">

                          <td *ngIf="bs.billetNumber !== element.billetNumber">{{bs.billetNumber}}</td>
                          <td *ngIf="bs.billetNumber !== element.billetNumber">
                            {{(element.dataReceiving.length -1) === i ?'parcial':'total'}}</td>

                        </tr>

                      </table>
                    </div>

                  </ng-template>

                  <ng-template #htmlContentTooltipDevolution>
                    <div class="footerPreviewCustomDevoluiton">

                      <div class="row">
                        <div class="col">

                          <div class="form-group">
                            <label class="form-text" for="accountingGroupName"><strong>Grupo</strong></label>
                            <span class="form-text" id="accountingGroupName">
                              {{element.devolutionLine.accountingGroupName }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <label class="form-text" for="responsibleName"><strong>Responsavel</strong></label>
                            <span class="form-text" id="responsibleName"> {{element.responsibleName }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <label class="form-text" for="dateDevolution"><strong>Data</strong></label>
                            <span class="form-text" id="dateDevolution">
                              {{element.devolutionLine.dateDevolution | date : config.formatDate}}</span>
                          </div>
                        </div>
                      </div>

                    </div>

                  </ng-template>



                  <mat-icon *ngIf="element.error !== 1" class="iconInfo cursorCustom searchIcon"
                    (click)="actionRedirectIcon(element)">
                    search
                  </mat-icon>
                  <mat-icon *ngIf="(element['lineStatusString'] !== 'Succeeded')" class="iconInfo text-dark cursorCustom btnResresh"
                    (click)="onRefreshLine(element)">
                    refresh
                  </mat-icon>
                  
                  <mat-icon *ngIf="config.accounting" triggers="mouseenter:mouseleave" [autoClose]="true"
                    title="Contabilizado" class="iconInfo cursorCustom doneIcon">
                    done
                  </mat-icon>

                  <mat-icon *ngIf="element.typeErrorProcess === 'Negotiations' && element.lineStatusString ==='Failed'"
                    class="iconInfo cursorCustom warningIcon" (click)="openDialog(element.errorProcess)">
                    warning
                  </mat-icon>

                  <mat-icon *ngIf="element.typeErrorProcess === 'ErrorSystem' && element.lineStatusString ==='Failed'"
                    class="iconInfo cursorCustom errorIcon" (click)="openDialog(element.errorProcess)">
                    error
                  </mat-icon>

                  <mat-icon *ngIf="element.reasonForRejection && element.reasonForRejection.length > 0" placement="left"
                    class="iconInfo cursorCustom" triggers="mouseenter:mouseleave" [autoClose]="true"
                    [ngbTooltip]="htmlContentTooltipRejection">
                    info
                  </mat-icon>

                  <mat-icon
                    *ngIf="element[config.selectConfig.varResponse] === 4 || element[config.selectConfig.varResponse] === 8 "
                    placement="left" class="iconInfo cursorCustom" triggers="mouseenter:mouseleave" [autoClose]="true"
                    [ngbTooltip]="element[config.selectConfig.varResponse] === 4 ? htmlContentTooltipBillet:htmlContentTooltipDevolution">
                    info
                  </mat-icon>
                  <mat-icon *ngIf="element.error !== 1 && config.duplicate && element['lineStatusString'] === 'Pendency'" class="iconInfo cursorCustom searchIcon"
                    (click)="actionDeleteDuplicate(element)">
                    delete
                  </mat-icon>
                </div>

                <div *ngSwitchCase="'messages'">

                  <ng-template #htmlContentTooltipRejection>
                    <div class="footerPreviewCustomDevoluiton">

                      <label class="form-text" for="accountingGroupName"><strong>Motivos da Rejeição</strong></label>
                      <div class="row" *ngFor="let item of element.reasonsForRejection">
                        <div class="col">
                          <div class="form-group">
                            <span class="form-text" id="accountingGroupName">{{ item }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                  </ng-template>

                  <mat-icon *ngIf="element.reasonsForRejection && element.reasonsForRejection.length > 0 "
                    placement="left" class="iconInfo cursorCustom" triggers="mouseenter:mouseleave" [autoClose]="true"
                    [ngbTooltip]="htmlContentTooltipRejection">
                    info
                  </mat-icon>
                </div>

                <div *ngSwitchCase="'input'">
                  <!-- TODO -->
                </div>

                <div *ngSwitchCase="'iconCopy'">
                  {{'CUSTOMLIST.' + config.tableTranslate + '.' + 'VALUES.' + element[col] | translate}} <mat-icon>
                    content_copy</mat-icon>
                </div>

                <div *ngSwitchCase="'date'">
                  {{element[col] | date : config.formatDate }}
                </div>

                <div *ngSwitchCase="'currency'">
                  {{element[col] | currency}}
                </div>

                <div *ngSwitchCase="'replace'">
                  <div [ngSwitch]="element[col]">

                    <div *ngSwitchCase="0">
                      {{config.replaceValue}}
                    </div>
                    <div *ngSwitchDefault>

                      <span triggers="mouseenter:mouseleave" [autoClose]="true"
                        [ngbTooltip]="'CUSTOMLIST.' + config.tableTranslate + '.' + 'VALUES.' + element.dataFile.audit.error.name | translate">
                        {{'CUSTOMLIST.' + config.tableTranslate + '.' + 'VALUES.' + element[col] | translate}}
                      </span>

                    </div>
                  </div>

                </div>

                <div *ngSwitchDefault>
                  <div *ngIf="element[col] !== '' && element[col] !== null && element[col] !== 'unidefined'">
                    {{'CUSTOMLIST.' + config.tableTranslate + '.' + 'VALUES.' + element[col] | translate}}
                  </div>

                  <div *ngIf="element[col] === '' || element[col] === null || element[col] === 'unidefined'">
                    {{ '-' }}
                  </div>
                </div>

              </div>
            </mat-cell>
          </ng-container>
        </ng-container>

        <mat-header-row *matHeaderRowDef="cols"></mat-header-row>

        <mat-row (click)="onActionLine(row, $event)"
          [ngClass]="{'click': config.actionLine.status, 'selected':config.actionLine.paramSelected && row[config.actionLine.paramSelected[0]] === config.actionLine.paramSelected[1] && config.actionLine.typeActionLine === 'select' }"
          *matRowDef="let row; columns: cols;"></mat-row>

      </mat-table>
      <mat-paginator *ngIf="data" (page)="pageEvent = changePage($event)" [length]="config.page.totalElements"
        [pageSizeOptions]="config.pageSize" [pageSize]="config.page.size" [pageIndex]="config.page.index"
        [showFirstLastButtons]="true"></mat-paginator>
    </div>
  </div>
</div>
